import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../Common/Buttons/Button";

interface ContributionActionsProps {
  isUserEnrolled?: boolean;
  isSubmitting: boolean;
  currentStep: number;
  totalSteps?: number;
  onPrevious: () => void;
  onNext: () => void;
  nextLabel?: string;
  previousLabel?: string;
}

const ContributionActions: React.FC<ContributionActionsProps> = ({
  isUserEnrolled,
  isSubmitting,
  currentStep,
  totalSteps = 4,
  onPrevious,
  onNext,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`flex items-center space-x-4 lg:space-x-0 bg-white ${
        isUserEnrolled
          ? "gap-4"
          : "justify-between mt-[24px] md:shadow-md rounded-[16px] px-0 py-[32px] md:p-[32px]"
      }`}
    >
      <div className={`${isUserEnrolled ? "w-full" : "w-[218px]"}`}>
        <Button
          ariaLabel="previous"
          variant="secondary"
          label={t("common.buttons.previous")}
          iconAlignment="left"
          handleClick={onPrevious}
        />
      </div>

      {!isUserEnrolled && (
        <div className="hidden lg:block flex-1 text-center">
          <p className="leading-[127%] font-normal text-[14px] text-[#C6C6C6]">
            {t("common.progress.step_counter", {
              current: currentStep + 2,
              total: totalSteps,
            })}
          </p>
        </div>
      )}

      <div className={`${isUserEnrolled ? "w-full" : "w-[218px]"}`}>
        <Button
          iconVisibility="show"
          ariaLabel="next"
          label={t("common.buttons.next")}
          loading={isSubmitting}
          handleClick={onNext}
        />
      </div>
    </div>
  );
};

export default ContributionActions;
